import ENV_VARS from '@/config'
import { post, get } from '@/ports/api'

const { BACKEND_SERVER } = ENV_VARS

const postPersonaSession = post(`${BACKEND_SERVER}/external/persona/session`, {
  noLoading: true
})

export const getPersonaSession = get(`${BACKEND_SERVER}/external/persona/session`, {
  noLoading: true
})

export const sendPersonaSession = (inquiryId: string) =>
  postPersonaSession({ body: { inquiry_id: inquiryId } })
